import { now, today } from 'owa-datetime';
import { TaskImportance } from 'owa-todo-types';
import { orchestrator } from 'satcheljs';
import {
    deleteTodo,
    markTodoComplete,
    markTodoIncomplete,
    markTodoImportant,
    removeTodoImportance,
    updateTodo,
    updateTodoDueDate,
    updateTodoReminder,
    updateTodoSubject,
    addTodoToMyDay,
    removeTodoFromMyDay,
} from '../actions/publicActions';
import { deleteTodo as deleteTodoAction } from 'owa-todo-cache';
import { updateTodoInternal } from './updateTodoInternal';

orchestrator(updateTodo, actionMessage => {
    updateTodoInternal(actionMessage.todoId, actionMessage.todoUpdates);
});

export const markTodoCompleteOrchestrator = orchestrator(markTodoComplete, actionMessage => {
    updateTodoInternal(actionMessage.todoId, {
        Status: 'Completed',
        CompletedDateTime: now(),
    });
});

export const markTodoInCompleteOrchestrator = orchestrator(markTodoIncomplete, actionMessage => {
    updateTodoInternal(actionMessage.todoId, {
        Status: 'NotStarted',
    });
});

orchestrator(markTodoImportant, actionMessage => {
    updateTodoInternal(actionMessage.todoId, {
        Importance: TaskImportance.High,
    });
});

orchestrator(removeTodoImportance, actionMessage => {
    updateTodoInternal(actionMessage.todoId, {
        Importance: TaskImportance.Normal,
    });
});

export const updateSubjectOrchestrator = orchestrator(updateTodoSubject, actionMessage => {
    updateTodoInternal(actionMessage.todoId, { Subject: actionMessage.subject });
});

export const deleteTodoOrchestrator = orchestrator(deleteTodo, actionMessage => {
    deleteTodoAction(actionMessage.todoId);
});

export const updateTodoReminderOrchestrator = orchestrator(updateTodoReminder, actionMessage => {
    updateTodoInternal(actionMessage.todoId, {
        ReminderDateTime: actionMessage.reminderDateTime,
        IsReminderOn: actionMessage.reminderDateTime != null,
    });
});

export const updateTodoDueDateOrchestrator = orchestrator(updateTodoDueDate, actionMessage => {
    updateTodoInternal(actionMessage.todoId, {
        DueDateTime: actionMessage.dueDate,
    });
});

export const addTodoToMyDayOrchestrator = orchestrator(addTodoToMyDay, actionMessage => {
    updateTodoInternal(actionMessage.todoId, {
        CommittedDay: today(),
        CommittedOrder: now(),
    });
});

export const removeTodoFromMyDayOrchestrator = orchestrator(removeTodoFromMyDay, actionMessage => {
    updateTodoInternal(actionMessage.todoId, {
        CommittedDay: undefined,
        CommittedOrder: undefined,
    });
});
